// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export enum ConflictResolutionMode {
  Custom = "Custom",
  LastWriterWins = "LastWriterWins",
}
